/* eslint-disable func-names */
/* eslint-disable camelcase */
import slugify from 'slugify';
import { STEPS } from '../containers/PcModel/constants';

const isString = (x) => typeof x === 'string';

export const replaceAll = (find, replace, str) => {
  if (typeof str !== 'string') throw new Error('str is not String');
  return str.replace(find, replace);
};

export const groupSlugify = (group_type) => replaceAll(
  /[-]/g,
  '_',
  slugify(group_type).toLocaleLowerCase(),
)

export function ProductSubGroup({
  option_id,
  option_sub_group_id = 0,
  group_type = 'None',
  sub_group_name,
  sub_group_title,
  sub_group_description,
  pc_model_uid,
  pc_model_title,
  priority,
}) {
  this.option_id = option_id; 
  this.option_sub_group_id = option_sub_group_id;
  this.group_type = groupSlugify(group_type);
  this.sub_group_name = sub_group_name ?? 'Untitled';
  this.sub_group_title = sub_group_title ?? 'Untitled';
  this.sub_group_description = sub_group_description;
  this.pc_model_uid = pc_model_uid;
  this.pc_model_title = pc_model_title;
  this.priority = priority;
}

export function ProductOption({
  price,
  compare_at,
  option_id,
  group_type = "None",
  option_sub_group_id = 0,
  group_title,
  group_step_new,
  id,
  title,
  sku,
  is_base,
  is_recommended,
  image,
  variant_id,
  tags,
  pc_model_uid,
  pc_model_title,
  o_price,
  // filter_by_brand,
}) {
  this.price = price
  this.compare_at = compare_at
  this.option_id = option_id
  this.group_type = groupSlugify(group_type)
  this.option_sub_group_id = option_sub_group_id;
  this.group_title = group_title;
  this.group_step_new = isString(group_step_new)
    ? group_step_new.toLowerCase()
    : STEPS[0];
  this.id = id;
  this.title = title;
  this.sku = sku;
  this.is_base = is_base;
  this.is_recommended = is_recommended;
  this.image = image;
  this.variant_id = variant_id;
  this.tags = tags;
  this.pc_model_uid = pc_model_uid;
  this.pc_model_title = pc_model_title;
  this.o_price = o_price;
  // this.filter_by_brand = filter_by_brand
}

ProductOption.prototype.toJson = function () {
  return JSON.stringify({
    option_id: this.option_id = option_id,
    group_type: this.group_type,
    option_sub_group_id: this.option_sub_group_id = option_sub_group_id,
    group_title: this.group_title = group_title,
    group_step_new: this.group_step_new,
    id: this.id = id,
    title: this.title = title,
    sku: this.sku = sku,
    is_base: this.is_base = is_base,
    is_recommended: this.is_recommended = is_recommended,
    image: this.image = image,
    variant_id: this.variant_id = variant_id,
    tags: this.tags = tags,
    pc_model_uid: this.pc_model_uid = pc_model_uid,
    pc_model_title: this.pc_model_title = pc_model_title,
    o_price: this.pc_model_title = o_price,
  });
};

export function ProductStock({ variant_id, quantity, tracked, policy }) {
  this.variant_id = variant_id;
  this.quantity = quantity;
  this.tracked = tracked;
  this.policy = policy;
}

ProductStock.prototype.toJson = function () {
  return JSON.stringify({
    variant_id: this.variant_id,
    quantity: this.quantity,
    tracked: this.tracked,
    policy: this.policy,
  });
};

export function ProductPrice({
  option_id,
  base_price,
  compared_at_price_diff,
  group_type = "None",
  pc_model_uid,
  price_diff,
  sku,
  variant_id,
}) {
  this.option_id = option_id
  this.base_price = base_price;
  this.compared_at_price_diff = compared_at_price_diff;
  this.group_type = groupSlugify(group_type)
  this.pc_model_uid = pc_model_uid;
  this.price_diff = price_diff;
  this.sku = sku;
  this.variant_id = variant_id;
}

ProductPrice.prototype.toJson = function () {
  return JSON.stringify({
    option_id: this.option_id,
    base_price: this.base_price,
    compared_at_price_diff: this.compared_at_price_diff,
    group_type: this.group_type,
    pc_model_uid: this.pc_model_uid,
    price_diff: this.price_diff,
    sku: this.sku,
    variant_id: this.variant_id,
  });
};

ProductOption.prototype.toJS = function () {
  return toJS(this);
};
ProductStock.prototype.toJS = function () {
  return toJS(this);
};
ProductPrice.prototype.toJS = function () {
  return toJS(this);
};

function toJS(originObj) {
  const obj = {};
  // eslint-disable-next-line no-restricted-syntax
  for (const key in originObj) {
    if (Object.hasOwnProperty.call(originObj, key)) {
      const element = originObj[key];
      obj[key] = element;
    }
  }
  return obj;
}
